import convertToArray from './convertToArray';
import StopScroll from './StopScroll';

class SettingPayment {
  init() {
    this.doc = document;
    this.cardInfoDialog = this.doc.getElementById('cardInfoDialog');
    this.cardInfoDialogActiveClass = 'is_active';
    this.closeCardInfoBtn = this.doc.getElementById('closeCardInfoBtn');
    this.cardInfoFormItem = convertToArray(this.cardInfoDialog.querySelectorAll('input, select'));
    this.cardInfoFormItemLen = this.cardInfoFormItem.length;
    this.submitCardInfoBtn = this.doc.getElementById('submitCardInfoBtn');
    this.submitBtn = this.doc.getElementById('submitBtn');
    this.sendDialog = this.doc.getElementById('sendDialog');
    this.sendDialogActiveClass = 'is_active';
    this.closeSendBtnAttr = 'data-close-send-btn';
    this.closeSendBtn = convertToArray(this.doc.querySelectorAll(`[${this.closeSendBtnAttr}]`));
    this.closeSendBtnLen = this.closeSendBtn.length;
    this.backdrop = this.doc.getElementById('backdrop');
    this.backdropActiveClass = 'is_active';
    this.openCardInfo = this.openCardInfo.bind(this);
    this.closeCardInfo = this.closeCardInfo.bind(this);
    this.submitCardInfo = this.submitCardInfo.bind(this);
    this.submit = this.submit.bind(this);
    this.closeSend = this.closeSend.bind(this);
    this.stopScroll = new StopScroll();
  }
  start() {
    this.openCardInfoBtn = document.getElementById('openCardInfoBtn');
    if (!this.openCardInfoBtn) return;
    this.init();
    this.openCardInfoBtn.addEventListener('click', this.openCardInfo);
    this.submitBtn.addEventListener('click', this.submit);
  }
  openCardInfo() {
    this.cardInfoDialog.classList.add(this.cardInfoDialogActiveClass);
    this.backdrop.classList.add(this.backdropActiveClass);
    for (let ii = 0; ii < this.cardInfoFormItemLen; ii += 1) {
      this.cardInfoFormItem[ii].disabled = false;
    }
    this.submitCardInfoBtn.addEventListener('click', this.submitCardInfo);
    this.closeCardInfoBtn.addEventListener('click', this.closeCardInfo);
    this.backdrop.addEventListener('click', this.closeCardInfo);
    this.stopScroll.stop();
  }
  closeCardInfo(e) {
    e.preventDefault();
    this.cardInfoDialog.reset();
    this.cardInfoDialog.classList.remove(this.cardInfoDialogActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    for (let ii = 0; ii < this.cardInfoFormItemLen; ii += 1) {
      this.cardInfoFormItem[ii].disabled = true;
    }
    this.submitCardInfoBtn.removeEventListener('click', this.submitCardInfo);
    this.closeCardInfoBtn.removeEventListener('click', this.closeCardInfo);
    this.backdrop.removeEventListener('click', this.closeCardInfo);
    this.stopScroll.reStart();
  }
  submitCardInfo(e) {
    this.closeCardInfo(e);
  }
  submit() {
    this.sendDialog.classList.add(this.sendDialogActiveClass);
    this.backdrop.classList.add(this.backdropActiveClass);
    for (let bi = 0; bi < this.closeSendBtnLen; bi += 1) {
      this.closeSendBtn[bi].addEventListener('click', this.closeSend);
    }
    this.backdrop.addEventListener('click', this.closeSend);
    this.stopScroll.stop();
  }
  closeSend(e) {
    e.preventDefault();
    this.sendDialog.classList.remove(this.sendDialogActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    for (let bi = 0; bi < this.closeSendBtnLen; bi += 1) {
      this.closeSendBtn[bi].removeEventListener('click', this.closeSend);
    }
    this.backdrop.removeEventListener('click', this.closeSend);
    this.stopScroll.reStart();
  }
}
export default SettingPayment;



// WEBPACK FOOTER //
// ./src/js/module/SettingPayment.js